<template>
    <add-edit-escalationfactor-barrier></add-edit-escalationfactor-barrier>
</template>

<script>
import AddEditEscalationfactorBarrier from "@/layouts/components/risk-management/escalation-factor-barriers/addedit-escalationfactor-barrier.vue";

export default {
 components : {
   AddEditEscalationfactorBarrier
 },
};
</script>